import Hero from "@/components/ui/Hero";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Terms() {
    useDocumentTitle(
        "Terms / Service Disclaimer · A1 Screening · Naples, FL",
        "Terms and service disclaimer for A1 Screening. Estimates, photo estimates, storm repair availability, and SMS terms for Naples and Southwest Florida."
    );
    return (
        <>
            <Hero eyebrow="Legal" title="Terms / Service Disclaimer" />
            <section className="a1-section">
                <div className="a1-container max-w-3xl space-y-4 text-[var(--color-text)]">
                    <h3>Estimates</h3>
                    <p>
                        All estimates are free. Pricing depends on enclosure size, panels, screen material, access, storm damage, and structural needs. Final pricing is confirmed after technician review.
                    </p>

                    <h3>Photo estimates</h3>
                    <p>
                        Photos help us understand the project before our follow-up. Final recommendations and pricing are confirmed after technician review.
                    </p>

                    <h3>Storm repair availability</h3>
                    <p>
                        Storm repair availability may vary by schedule and season. We do not promise same-day service or round-the-clock emergency response.
                    </p>

                    <h3>Text-message terms</h3>
                    <p>
                        Text messages from A1 Screening are <strong>service-related / customer-care communications</strong> — for example, appointment confirmations, estimate follow-ups, and responses to questions you sent us through our forms. A1 Screening does not send marketing or promotional SMS.
                    </p>
                    <p>
                        Message and data rates may apply. Message frequency varies based on your service request. Carriers are not liable for delayed or undelivered messages. SMS opt-out is available at any time — reply <strong>STOP</strong> to any text message and we'll stop texting you. Reply <strong>HELP</strong> for help, or contact us at <a href="tel:+12394347306">239-434-7306</a> or <a href="mailto:info@a1screening247.com">info@a1screening247.com</a>.
                    </p>
                    <p>
                        See our <a href="/privacy-policy">Privacy Policy</a> for details on how we use the contact information you share with us.
                    </p>

                    <h3>Warranty / Guarantee</h3>
                    <p>
                        Any warranty or guarantee details should be confirmed directly with A1 Screening before relying on them. Do not assume a warranty applies unless A1 Screening confirms it in writing for your specific project.
                    </p>

                    <h3>License / Insurance</h3>
                    <p>
                        Any license, registration, or insurance details should be confirmed directly with A1 Screening before relying on them. This website does not make a license or insurance claim unless those details are separately verified.
                    </p>

                    <h3>Contact</h3>
                    <p>
                        A1 Screening · Naples, FL · serving Southwest Florida · phone <a href="tel:+12394347306">239-434-7306</a> · email <a href="mailto:info@a1screening247.com">info@a1screening247.com</a> · hours 7:00 AM – 5:00 PM.
                    </p>
                </div>
            </section>
        </>
    );
}
